<app-toolbar></app-toolbar>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>